import React from "react"
import { createUseStyles } from "react-jss"

export const Flex = ({
  children,
  gap = null,
  direction = null,
  align = null,
  style = null,
  custom = {},
}) => {
  const styles = createUseStyles({
    flex: {
      display: "flex",
      flexDirection: direction,
      gap: gap,
      alignItems: align,
      ...custom,
    },
  })()
  return (
    <div className={styles.flex} style={style}>
      {children}
    </div>
  )
}
